import { ApiAudience } from "../../../views/marketing-pages/create-campaign/types";

// The Messaging step's "Map data source → CSV Column" dropdowns, Column
// Preview and message preview read localStorage.csv_headers +
// first_row_values (+ metadata for the file name). Only the Upload tab used
// to write those, so picking a saved audience — or editing a draft built on
// one — left them empty even though GET /audience/list returns each
// audience's own `csv_headers` and `first_row_values`. This writes the same
// keys from the selected saved audiences: headers merged in order across them
// (de-duplicated), each header's sample value taken from the first audience
// that has that column, file name from the first one with headers.
// Returns false (and clears the keys) when none of them carry headers.
export function applySavedAudienceHeaders(audiences: Pick<ApiAudience, "csv_headers" | "first_row_values" | "metadata">[]): boolean {
  const withHeaders = audiences.filter((a) => Array.isArray(a.csv_headers) && a.csv_headers.length > 0);
  if (withHeaders.length === 0) {
    localStorage.removeItem("csv_headers");
    localStorage.removeItem("first_row_values");
    localStorage.removeItem("metadata");
    return false;
  }
  const sample = new Map<string, string | number | null>();
  withHeaders.forEach((a) =>
    (a.csv_headers as string[]).forEach((h, i) => {
      if (!sample.has(h)) sample.set(h, a.first_row_values?.[i] ?? null);
    })
  );
  const headers = Array.from(sample.keys());
  localStorage.setItem("csv_headers", JSON.stringify(headers));
  localStorage.setItem("first_row_values", JSON.stringify(headers.map((h) => sample.get(h) ?? null)));
  if (withHeaders[0].metadata) localStorage.setItem("metadata", JSON.stringify(withHeaders[0].metadata));
  return true;
}
